import React from 'react'
import PropTypes from 'prop-types'
import { Spacer } from '../'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
`

const Wrapper = ({ children }) => {
  return (
    <Container>
      <Spacer size={4} vertical />
      {children}
      <Spacer size={4} vertical />
    </Container>
  )
}


Wrapper.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Wrapper
